'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamor = require('glamor');

var fontFace = function fontFace(font) {
  return _glamor.css.fontFace(font);
};

exports.default = fontFace;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fontFace.js
// module id = 362
// module chunks = 0